import { OrderResponse } from "types/order.types";
import { BaseResponse } from "types/responses.type";
import api from "./api";

interface GetOrdersParams {
  page?: number;
  pageSize?: number;
  startDate?: string;
  endDate?: string;
  search?: string;
}

class OrdersService {
  async getOrders(
    params: GetOrdersParams = {}
  ): Promise<BaseResponse<OrderResponse[]>> {
    const response = await api.get("/orders", { params });
    return response.data;
  }

  async getOrder(id: string): Promise<BaseResponse<OrderResponse>> {
    const response = await api.get(`/orders/${id}`);
    return response.data;
  }
}

export default new OrdersService();
